import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useLocation } from '../hooks'
import { removeMessage } from '../slices/ui'

import CloseIcon from '../icons/close.svg';

const Message = (props) => {
  const {id, message, status='info', actions=null, timeout=null, premanent=false} = props
  const dispatch = useDispatch()
  const [pathname, search] = useLocation()

  useEffect(()=>{
    let timeoutID = null

    if (timeout) {
      timeoutID = setTimeout(
        () => dispatch(removeMessage(id))
      , timeout * 1000)
    }
    return () => timeoutID && clearTimeout(timeoutID)

  }, [id, timeout, dispatch])

  useEffect(()=>{
    if (premanent) return
    return () => {
      dispatch(removeMessage(id))
    }
  }, [pathname, search, premanent, dispatch])

  return (
    <li className={`pwa__message fade-in ${status}`}>
      {message}
      <button className="button basic circular"
              onClick={ () => dispatch(removeMessage(id)) }>
        <CloseIcon/>
      </button>
      { actions && actions.map( action => (
        <button className="pwa__message__action button"
                onClick={action.onClick}>
          {action.text}
        </button>
      ))}
    </li>
  )
}

export default Message


